import React from "react";
import { ArrowDown } from "lucide-react";
import { site, heroBg } from "../mock";
import { useContent } from "../context/ContentContext";

export default function Hero() {
  const { content } = useContent();
  const { hero, bookUrl, locationsBanner } = content.settings;

  return (
    <section
      id="top"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-[#0C0C0C] text-center px-6"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroBg})`, opacity: 0.9 }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0C0C0C]/75 via-[#0C0C0C]/30 to-[#0C0C0C]/85" />
      <div className="absolute inset-0 bg-[#0C0C0C]/10" />
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[560px] w-[560px] rounded-full bg-[#C6A15B]/12 blur-[130px]" />
      </div>

      <div className="relative z-10 flex flex-col items-center">
        <p className="tracking-luxe uppercase text-[11px] md:text-xs text-[#C6A15B] mb-6">
          {hero.eyebrow}
        </p>

        <img
          src={site.logo}
          alt="Skinplicity Wellness"
          className="w-72 md:w-[26rem] h-auto select-none -mb-4 md:-mb-8 drop-shadow-[0_0_40px_rgba(198,161,91,0.25)]"
          draggable={false}
        />

        <h1 className="font-serif-display text-[#F7F2EA] leading-[0.95]">
          {(hero.titleLines || []).map((line, i) => (
            <span
              key={i}
              className={`block text-5xl md:text-8xl ${i === 1 ? "italic text-[#C6A15B]" : ""}`}
            >
              {line}
            </span>
          ))}
        </h1>

        <p className="max-w-xl text-[#C9C3B6] text-sm md:text-base leading-relaxed mt-8 font-light">
          {hero.subtitle}
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
          <a
            href={bookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#C6A15B] text-[#0C0C0C] text-xs tracking-[0.2em] uppercase px-9 py-4 hover:bg-[#d8b877] transition-colors duration-300"
          >
            Book an Appointment
          </a>
          <a
            href="#services"
            className="border border-[#C6A15B]/50 text-[#EDE7DA] text-xs tracking-[0.2em] uppercase px-9 py-4 hover:border-[#C6A15B] hover:text-[#C6A15B] transition-colors duration-300"
          >
            Explore Services
          </a>
        </div>

        <p className="mt-10 text-[11px] tracking-[0.2em] uppercase text-[#8A857A]">
          {(locationsBanner || []).join("  \u00b7  ")}
        </p>
      </div>

      <a
        href="#about"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#C6A15B] animate-bounce z-10"
        aria-label="Scroll down"
      >
        <ArrowDown size={22} />
      </a>
    </section>
  );
}
